import React, { Component } from "react";
import { FaInfoCircle } from "react-icons/fa";

import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import ReactToPrint from "react-to-print";

import Select, { components } from "react-select";

import { Translate, I18n } from "react-redux-i18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setAlert } from "../../actions/alertActions";
import {
  searchModule,
  momentModule,
  roundToDecimals,
  parseAddress,
  isValidDurationCdr,
  getTranslationKeyPaymentStatus,
  getOptionsNetwork,
  overcostMap,
  overtimeMap,
  plugChoiceMap,
  getNewCountryCode,
} from "../utils/Utils";
import ComponentSelector from "../utils/components/ComponentSelector";
import PageSelector from "../utils/components/pageSelector/PageSelector";
import ChargerSessionSummary from "./history/ChargerSessionSummary";
import Report from "./reports/Report";
import "../../styles/components/insights/History.scss";
import arrow from "../../styles/images/arrow_long.svg";
import download from "../../styles/images/download.svg";
import ChoiceModal from "../utils/components/ChoiceModal";
import toggle from '../utils/evio-toggle';
import { ReactComponent as CarIcon } from "../../styles/images/car_icon.svg";
import { ReactComponent as StationIcon } from "../../styles/images/station_icon.svg";
const { moment, formatDate } = momentModule;

class History extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
    this.cancelFetch = null;
    this.componentRef = null;

    this.state = {
      from: moment().subtract(1, "month").startOf("day"),
      to: moment().endOf("day"),

      search: "",
      exportData: null,
      selectedTab: 0,

      // order = true ascending in value or in alphabetic order
      order: true,
      // field that is currently sorting the table
      sortField: "",
      // path to the sortfield in the api request response
      sortFieldGetter: () => null,

      fleets: [],
      groups: [],
      infrastructures: [],
      csGroups: [],

      //updated filters
      fleetFilter: [],

      //new
      selectedFleet: null,
      selectedEv: null,
      selectedGroup: null,
      selectedUser: null,
      selectedNetwork: null,
      selectedFleetCharger: null,
      selectedInfrastructure: null,
      selectedCharger: null,
      selectedOther: null,
      selectedUserFilter: null,

      evs: {
        filter: { fleet: "", ev: "", group: "", user: "", network: "" },
        withVat: false,
        pageNumber: 1,
        resultsLimit: 10,
        totalPages: 0,
        totalEntries: 0,

        loading: true,
        sessions: [],
      },

      chargers: {
        filter: {
          infrastructure: "",
          charger: "",
          fleet: "",
          ev: "",
          group: "",
          user: "",
        },
        withVat: false,
        pageNumber: 1,
        resultsLimit: 10,
        totalPages: 0,
        totalEntries: 0,

        loading: true,
        sessions: [],
      },

      selectedItem: null,
      modals: {
        choice: false,
        info: false,
      },

      evioTogglePlugChoice: false,
      listOfCountries: [],
      listOfSelectedCountries: [],
    };

    this.displayNames = new Intl.DisplayNames(
          [getNewCountryCode(this.props.language.locale)],
          { type: "region" }
        );

    this.initializeHistory = this.initializeHistory.bind(this);
    this.handleOnChoose = this.handleOnChoose.bind(this);
    this.handleOnChangeFilter = this.handleOnChangeFilter.bind(this);
    this.handleOnChangeWithVat = this.handleOnChangeWithVat.bind(this);
    this.handleOnChangeResultsLimit =
      this.handleOnChangeResultsLimit.bind(this);
    this.handleOnPageSwitch = this.handleOnPageSwitch.bind(this);
    this.selectTab = this.selectTab.bind(this);
    this.sortTableRows = this.sortTableRows.bind(this);
    this.authTypeTranslationKey = this.authTypeTranslationKey.bind(this);
    this.customStyles = this.customStyles.bind(this);
    this.getPlugTypeUsed = this.getPlugTypeUsed.bind(this);
    this.getPotencyUsed = this.getPotencyUsed.bind(this);
    this.renderOvercost = this.renderOvercost.bind(this);
    this.renderPlugchoice = this.renderPlugchoice.bind(this);
    this.renderTooltipOvercostColumn =
      this.renderTooltipOvercostColumn.bind(this);
    this.renderTooltipOvertimeColumn =
      this.renderTooltipOvertimeColumn.bind(this);
    this.renderTooltipPlugChoiceColumn =
      this.renderTooltipPlugChoiceColumn.bind(this);
    this.overcostClassification = this.overcostClassification.bind(this);
    this.efficiencyClassification = this.efficiencyClassification.bind(this);
    this.plugChoiceClassification = this.plugChoiceClassification.bind(this);
    this.getAvailableCountries = this.getAvailableCountries.bind(this);
  }

  async safeSetStateWithAwait() {
    await toggle.connect();
    const isEnabled = await toggle.isEnable("fleet-887-columns");
    const flagPlugChoice = await toggle.isEnable("fleet-785-plug-choice");
    if (this._mounted) {
      this.getAvailableCountries()
      this.setState(
        {
          evioToggle: isEnabled,
          evioTogglePlugChoice: flagPlugChoice,
        },
        this.initializeHistory,
      );
    }
  }

  componentDidMount() {
    this._mounted = true;
    this.safeSetStateWithAwait();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language.locale !== this.props.language.locale) {
      this.displayNames = new Intl.DisplayNames(
        [getNewCountryCode(this.props.language.locale)],
        { type: "region" }
      );
    }
  }

  getAvailableCountries() {
    // This will fetch the list of available countries
    axios
      .get("/api/private/countries/available", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const countryCodes = res.data.map((country) => country.countryCode);
          const countryOptions = [
            { label: "ALL", value: "All" },
            ...countryCodes.map((code) => ({ label: code, value: code })),
          ];
          this.safeSetState({
            listOfCountries: countryOptions,
            listOfSelectedCountries: countryOptions, // select all by default
          });

        }
      })
      .catch((err) => {
        this.props.setAlert(I18n.t("general_error"), "danger");
      });
  }

  sortTableRows(column, fieldGetter) {
    let order = this.state.order;
    let sortField = this.state.sortField;
    let sortFieldGetter = this.state.sortFieldGetter;

    if (column === sortField) {
      order = !order;
    } else {
      sortField = column;
      sortFieldGetter = fieldGetter;
      order = true;
    }

    this.safeSetState({ order, sortField, sortFieldGetter }, this.fetchHistory);
  }

  initializeHistory() {
    Promise.all([
      this.fetchFleets(),
      this.fetchGroups(),
      this.fetchInfrastructures(),
      this.fetchCSGroups(),
    ]).then(([fleetsRes, groupsRes, infrastructureRes, csGroupsRes]) => {
      const fleets = fleetsRes.data;
      const groups = groupsRes.data;
      const infrastructures = infrastructureRes.data;
      const csGroups = csGroupsRes.data;
      this.safeSetState(
        { fleets, groups, infrastructures, csGroups },
        this.fetchHistory
      );
    });
  }

  fetchHistory(
    type = this.state.selectedTab === 0 ? "evs" : "chargers",
    { toExport = false, callback = () => {}, withVat = false, idx = 0 } = {}
  ) {
    this.safeSetState(
      (prevState) => ({ [type]: { ...prevState[type], loading: true } }),
      () => {
        const buildFilterPacket = () => {
          const fleetObj = this.state.fleets[this.state[type].filter.fleet];
          const evObj =
            fleetObj && fleetObj.listEvs[this.state[type].filter.ev];
          const fleet =
            (fleetObj && fleetObj._id) ||
            this.state[type].filter.fleet ||
            undefined;
          const evId = evObj && evObj.evId;

          // Extract selected countries, ignoring 'ALL' and 'toggle all'
          let selectedCountries = (this.state.listOfSelectedCountries || [])
            .filter((opt) => opt.value !== "All" && opt.label !== "ALL")
            .map((opt) => opt.value);

          // If all countries are selected (ALL), send empty string
          if (
            this.state.listOfSelectedCountries &&
            this.state.listOfCountries &&
            this.state.listOfSelectedCountries.length === this.state.listOfCountries.length
          ) {
            selectedCountries = [];
          }

          // Always return as array (empty if all selected)
          const country = selectedCountries;

          if (type === "evs") {
            const groupObj = this.state.groups[this.state[type].filter.group];
            const userObj =
              groupObj && groupObj.listOfDrivers[this.state[type].filter.user];

            const groupDriverId = groupObj && groupObj._id;
            const driverId = userObj && userObj.driverId;
            const network = this.state[type].filter.network || undefined;

            return { fleet, evId, groupDriverId, driverId, network, country };
          } else {
            const infrastructureObj =
              this.state.infrastructures[
                this.state[type].filter.infrastructure
              ];
            const chargerObj =
              infrastructureObj &&
              infrastructureObj.listChargers[this.state[type].filter.charger];
            const groupObj = this.state.csGroups[this.state[type].filter.group];

            let removeNotRegistedUsers = groupObj && groupObj.listOfUsers;
            if (removeNotRegistedUsers) {
              removeNotRegistedUsers = removeNotRegistedUsers.filter(
                (obj) => obj.userId !== ""
              );
            }
            const csUserObj =
              removeNotRegistedUsers &&
              removeNotRegistedUsers[this.state[type].filter.user];

            const infrastructure = infrastructureObj && infrastructureObj._id;
            const hwId = chargerObj && chargerObj.hwId;
            const csGroupId =
              (groupObj && groupObj._id) ||
              this.state[type].filter.group ||
              undefined;
            const csUserId =
              this.state[type].filter.group !== "Others"
                ? csUserObj && csUserObj.userId
                : this.state[type].filter.user;

            return {
              infrastructure,
              hwId,
              fleet,
              evId,
              csGroupId,
              csUserId,
              country,
            };
          }
        };

        const sortSessions = (sessions) => {
          sessions.sort((a, b) => {
            if (!this.state.order) {
              const temp = a;
              a = b;
              b = temp;
            }

            const val_a = this.state.sortFieldGetter(a);
            const val_b = this.state.sortFieldGetter(b);

            if (typeof val_a == "number") {
              return val_a - val_b;
            }
            if (typeof val_a == "string") {
              return val_a.localeCompare(val_b);
            }
          });

          return sessions;
        };

        //idx 0 == csv idx 1 == xlsx
        const isCSV = idx === 0;
        const isExcel = idx === 1;

        if (this.cancelHistory) this.cancelHistory("New request made");
        axios
          .get("/api/private/history_v2", {
            cancelToken: new CancelToken((c) => (this.cancelHistory = c)),
            responseType: toExport ? "blob" : null,
            params: {
              type,
              startDate: new Date(this.state.from),
              endDate: new Date(this.state.to),
              pageNumber: toExport ? 1 : this.state[type].pageNumber,
              limiteQuery: toExport
                ? this.state[type].totalEntries
                : this.state[type].resultsLimit,
              filter: buildFilterPacket(),
              ...(toExport
                ? {
                    exportCSV: isCSV,
                    exportExcel: isExcel,
                  }
                : {}),
            },
          })
          .then((res) => {
            if (res.status === 200) {
              if (toExport === false) {
                this.safeSetState((prevState) => ({
                  [type]: {
                    ...prevState[type],
                    totalPages: parseInt(res.headers.numberofpages),
                    totalEntries: parseInt(res.headers.totalofentries),
                    sessions: sortSessions(res.data),
                    loading: false,
                  },
                }));
              } else {
                // Handle blob download
                const fileExtension = isCSV ? "csv" : isExcel ? "xlsx" : "dat";
                const initialDate = moment(this.state.from)
                  .local()
                  .format("DD-MM-YYYY");
                const finalDate = moment(this.state.to)
                  .local()
                  .format("DD-MM-YYYY");
                const fileName = `${this.props.brand.brandTitle}_${I18n.t(
                  "insights_historyTabTitle"
                )}_${initialDate}_${finalDate}.${fileExtension}`;
                const mimeType = isCSV
                  ? "text/csv"
                  : isExcel
                  ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  : "application/octet-stream";
                const url = window.URL.createObjectURL(
                  new Blob([res.data], { type: mimeType })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                this.safeSetState((prevState) => ({
                  [type]: {
                    ...prevState[type],
                    loading: false,
                  },
                }));
              }
            }
          })
          .catch((err) => {
            this.safeSetState((prevState) => ({
              [type]: {
                ...prevState[type],
                loading: false,
              },
            }));
            this.setModal("choice", false);
            this.props.setAlert(I18n.t(err.response?.data?.message), "danger");
          });
        this.setModal("choice", false);
      }
    );
  }

  fetchFleets() {
    const endpoint = "/api/private/fleets/toAddOnChargerB2B";
    const config = {
      cancelToken: new CancelToken((c) => (this.cancelFetch = c)),
    };
    config.headers = { history: true };
    return axios.get(endpoint, config);
  }

  fetchGroups() {
    return axios.get("/api/private/groupDrivers", {
      cancelToken: new CancelToken((c) => (this.cancelFetch = c)),
    });
  }

  fetchInfrastructures() {
    return axios.get("/api/private/infrastructure/myInfrastructure", {
      cancelToken: new CancelToken((c) => (this.cancelFetch = c)),
    });
  }

  fetchCSGroups() {
    return axios.get("/api/private/groupCSUsers", {
      cancelToken: new CancelToken((c) => (this.cancelFetch = c)),
    });
  }

  handleOnDateChange(e, dateType) {
    const type = this.state.selectedTab === 0 ? "evs" : "chargers";
    const date = e.target.value;
    let fromDate = moment(date).startOf("day").toDate();
    const toDate = moment(date).endOf("day").toDate();
    this.safeSetState(
      (prevState) => ({
        [dateType]: dateType === "from" ? fromDate : toDate,
        [type]: {
          ...prevState[type],
          pageNumber: 1,
        },
      }),
      () => {
        let updatedState = {};

        let invalidTo = this.state.to == "Invalid Date";
        let invalidFrom = this.state.from == "Invalid Date";

        if (invalidFrom) {
          updatedState.from = moment()
            .subtract(1, "month")
            .startOf("day")
            .toDate();
        }
        if (invalidTo) {
          updatedState.to = moment().startOf("day").toDate();
        }

        if (Object.keys(updatedState).length > 0) {
          this.safeSetState(updatedState, this.fetchHistory);
        } else {
          this.fetchHistory();
        }
      }
    );
  }

  resetSelects(callback) {
    this.safeSetState(
      {
        search: "",
        filterEvs: {
          fleet: "All",
          ev: "All",
          group: "All",
          user: "All",
          network: "All",
        },
        filterChargers: {
          infrastructure: "All",
          charger: "All",
          fleet: "All",
          ev: "All",
          group: "All",
          user: "All",
        },
        myEvSessions: [],
        myChargerSessions: [],
        myFilteredSessions: [],
        selectedUsersFromGroupMyEvs: [],
        selectedEvsFromFleetMyEvs: [],
        selectedUsersFromGroupMyChargers: [],
        selectedEvsFromFleetMyChargers: [],
      },
      callback
    );
  }
  handleOnChangeFilter(e, filter, filterType) {
    const type = this.state.selectedTab === 0 ? "evs" : "chargers";
    const filterValue = e < 0 ? "" : e;
    this.safeSetState(
      (prevState) => {
        let newState = {
          [type]: {
            ...prevState[type],
            filter: {
              ...prevState[type].filter,
              [filter]: filterValue,
              // reset ev, user or charger if fleet, group or infrastructure changes, respectively
              [filter === "fleet"
                ? "ev"
                : filter === "group"
                ? "user"
                : filter === "infrastructure"
                ? "charger"
                : ""]: "",
            },
            pageNumber: 1,
          },
        };
        // Reset country filter if network is changed to "" or "INTERNAL"
        if (filter === "network" && (filterValue === "" || filterValue === "INTERNAL")) {
          newState.listOfSelectedCountries = [];
        }
        return newState;
      },
      this.fetchHistory
    );
  }

  handleOnChangeWithVat(e) {
    const type = this.state.selectedTab === 0 ? "evs" : "chargers";
    const withVat = e.target.checked;
    this.safeSetState(
      (prevState) => ({
        [type]: {
          ...prevState[type],
          withVat,
        },
      }),
      this.fetchHistory
    );
  }

  getPlugTypeUsed(charger, plug) {
    if (!charger || !Array.isArray(charger.plugs)) {
      return "-";
    }
    const listOfPlugs = charger.plugs;
    for (const iteratedPlug of listOfPlugs) {
      if (iteratedPlug?.plugId === plug) {
        return iteratedPlug?.connectorType;
      }
    }
    return "-";
  }

  getPotencyUsed(charger, plug) {
    if (!charger || !Array.isArray(charger.plugs)) {
      return "-";
    }
    const listOfPlugs = charger.plugs;
    for (const iteratedPlug of listOfPlugs) {
      if (iteratedPlug?.plugId === plug) {
        return roundToDecimals(iteratedPlug?.power, 4);
      }
    }
    return "-";
  }

  handleOnChoose(idx, mode) {
    if (idx < 2) {
      this.fetchHistory(mode, {
        toExport: true,
        idx,
      });
    }
  }

  prepareHistoryExport(fileType, mode, data) {
    const newData = [];
    const csvQuote = (value) => (fileType === "csv" ? `"${value}"` : value);
    const isValidValue = (value) => value && value !== "-1" && value !== "-";
    if (mode === "evs") {
      data.forEach((item) => {
        const exportItem = {
          [I18n.t("report_startDate")]: formatDate(
            moment(item.startDate).local(),
            "datetime"
          ),
          [I18n.t("report_stopDate")]: formatDate(
            moment(item.stopDate).local(),
            "datetime"
          ),
          [I18n.t("report_network")]:
            item.network !== "history_internalNetwork"
              ? isValidValue(item.network)
                ? item.network
                : isValidValue(item.charger?.network)
                ? item.charger.network
                : "-"
              : I18n.t("history_internalNetwork"),
          [I18n.t("report_fleet")]:
            (isValidValue(item.fleet?.name) && csvQuote(item.fleet.name)) ||
            I18n.t("history_other"),
          [I18n.t("report_ev")]:
            (isValidValue(item.evId) &&
              isValidValue(item.ev?.licensePlate) &&
              csvQuote(item.ev.licensePlate)) ||
            "-",
          [I18n.t("report_group")]: item.groupDrivers
          ? csvQuote(item.groupDrivers?.name)
          : "-",
          [I18n.t("report_user")]:
            typeof item.user === "object"
              ? csvQuote(item.user?.name) ?? "-"
              : I18n.t(`history_${mode === "chargers" ? "public" : "other"}`),
          [I18n.t("report_charger")]: item.hwId,
          [I18n.t("report_city")]:
            (isValidValue(item.charger?.address?.city) &&
              csvQuote(parseAddress(item.charger.address.city))) ||
            "-",
          [I18n.t("report_durationInMin")]: item.totalTimeInMinExcel || 0,
          [I18n.t("report_energyInKWh")]:
            roundToDecimals(item.totalPower, 4) || 0,
          [I18n.t("report_co2")]: roundToDecimals(item.CO2Saved, 4) || 0,
          [I18n.t("report_durationAfterCharge")]:
            item.timeAfterChargedInMinExcel || 0,
          [I18n.t("history_timeChargedInMin")]: item.timeChargedInMinExcel || 0,
          [I18n.t("report_timeCost")]: roundToDecimals(item.timeCost, 4) || "-",
          [I18n.t("report_energyCost")]:
            roundToDecimals(item.energyCost, 4) || "-",
          [I18n.t("report_activationFee")]: item.activationFee || "-",
          [I18n.t("report_tariffEnergy")]: item.tariffkWh || "-",
          [I18n.t("report_tariffTime")]: item.tariffMin || "-",
          [I18n.t("report_parkingDuringCharge")]:
            item.parkingDuringChargingAmount || "-",
          [I18n.t("report_parkingTariff")]: item.parkingAmount || "-",
          [I18n.t("report_mobieCemeTariff")]: item.cemeTariff || "-",
          [I18n.t("report_mobieCemeTotal")]:
            roundToDecimals(item.tariffsDetails?.ceme?.total, 4) || "-",
          [I18n.t("report_mobieTarTotal")]:
            roundToDecimals(item.tariffsDetails?.fees?.tar, 4) || "-",
          [I18n.t("report_mobieOpcTotal")]:
            roundToDecimals(item.tariffsDetails?.opc?.total, 4) || "-",
          [I18n.t("report_mobieSupportEM")]:
            item.supportElectricMobility || "-",
          [I18n.t("report_mobieEgmeTariff")]:
            roundToDecimals(item.egmeTariff, 4) || "-",
          [I18n.t("report_mobieIecTotal")]:
            roundToDecimals(item.tariffsDetails?.fees?.iec, 4) || "-",
          [I18n.t("report_costExclVat")]: isValidDurationCdr(item, "hours")
            ? "-"
            : roundToDecimals(item.totalPrice?.excl_vat, 4) || 0,
          [I18n.t("report_vatRate")]: item.vatRate || "-",
          [I18n.t("report_costInclVat")]: isValidDurationCdr(item, "hours")
            ? "-"
            : roundToDecimals(item.totalPrice?.incl_vat, 4) || 0,

          [I18n.t("myChargers_status")]:
            I18n.t(
              getTranslationKeyPaymentStatus(
                item.sessionBillingInfo?.sameUser.status
              )
            ) || "-",
          [I18n.t("kms_title")]: item?.evKms?.kms || "-",
          [I18n.t("addCard_cardNumber")]:
            item.cardNumber === "-1" ? "-" : item.cardNumber,
          [I18n.t("addCard_cardNumber")]:
            item.cardNumber === "-1" ? "-" : item.cardNumber,
          [I18n.t("report_costPerKwExclVat")]:
            roundToDecimals(item.costPerkWh?.excl_vat, 4) || 0,
          [I18n.t("report_costPerKwInclVat")]:
            roundToDecimals(item.costPerkWh?.incl_vat, 4) || 0,
          [I18n.t("history_overcost")]:
              !isNaN(item?.overcost)
                ? this.overcostClassification(
                    parseFloat(item?.overcost).toFixed(2)
                  ).title
                : !isNaN(parseFloat(item?.overcost))
                ? parseFloat(item?.overcost).toFixed(2)
                : "-",
          [I18n.t("history_efficiency")]:
              !isNaN(item?.efficiency)
                ? this.efficiencyClassification(
                    parseFloat(item?.efficiency).toFixed(2)
                  ).title
                : !isNaN(parseFloat(item?.efficiency))
                ? parseFloat(item?.efficiency).toFixed(2)
                : "-",
          [I18n.t("history_plugChoice")]:
            !isNaN(item?.plugChoice)
              ? this.plugChoiceClassification(
                  parseFloat(item?.plugChoice).toFixed(2)
                ).title
              : !isNaN(parseFloat(item?.plugChoice))
              ? parseFloat(item?.plugChoice).toFixed(2)
              : "-",
          [I18n.t("mapFilter_connectorType")]: this.getPlugTypeUsed(
            item?.charger,
            item?.plugId
          ),
          [I18n.t("chargerTitle_power")]: this.getPotencyUsed(
            item?.charger,
            item?.plugId
          ),
        };

        newData.push(exportItem);
      });
    } else if (mode === "chargers") {
      data.forEach((item) => {
        const exportItem = {
          [I18n.t("report_startDate")]: formatDate(
            moment(item.startDate).local(),
            "datetime"
          ),
          [I18n.t("report_stopDate")]: formatDate(
            moment(item.stopDate).local(),
            "datetime"
          ),
          [I18n.t("report_infrastructure")]:
            (item.infrastructure && csvQuote(item.infrastructure.name)) || "-",
          [I18n.t("report_group")]: item.groupDrivers
            ? csvQuote(item.groupDrivers.name) || "-"
            : I18n.t("history_other"),
          [I18n.t("report_charger")]: item.hwId,
          [I18n.t("report_cpe")]:
            (isValidValue(item.charger?.CPE) && item.charger.CPE) || "-",
          [I18n.t("report_city")]:
            (isValidValue(item.charger?.address?.city) &&
              csvQuote(parseAddress(item.charger.address.city))) ||
            "-",
          [I18n.t("report_durationInMin")]: item.totalTimeInMinExcel || 0,
          [I18n.t("history_timeChargedInMin")]: item.timeChargedInMinExcel || 0,
          [I18n.t("report_durationAfterCharge")]:
            item.timeAfterChargedInMinExcel || 0,
          [I18n.t("report_energyInKWh")]:
            roundToDecimals(item.totalPower, 4) || 0,
          [I18n.t("report_averageChargingPowerKW")]:
            Array.isArray(item.purchaseTariffDetails) &&
            item.purchaseTariffDetails?.kwhListAverage.length > 0
              ? item.purchaseTariffDetails?.kwhListAverage[0]
              : "-",
          [I18n.t("report_co2")]: roundToDecimals(item.CO2Saved, 4) || 0,
          [I18n.t("report_vatRate")]: item.vatRate || "-",
          [I18n.t("report_costExclVat")]:
            roundToDecimals(item.purchaseTariffDetails?.excl_vat, 4) || 0,
          [I18n.t("report_costInclVat")]:
            roundToDecimals(item.purchaseTariffDetails?.incl_vat, 4) || 0,
          [I18n.t("report_revenueExclVat")]:
            roundToDecimals(item.totalPrice?.excl_vat, 4) || 0,
          [I18n.t("report_revenueInclVat")]:
            roundToDecimals(item.totalPrice?.incl_vat, 4) || 0,
          [I18n.t("report_fleet")]:
            (isValidValue(item.fleet?.name) && csvQuote(item.fleet.name)) ||
            I18n.t("history_other"),
          [I18n.t("report_ev")]:
            (isValidValue(item.evId) &&
              isValidValue(item.ev?.licensePlate) &&
              csvQuote(item.ev.licensePlate)) ||
            "-",
          [I18n.t("report_user")]:
            typeof item.user === "object"
              ? csvQuote(item.user?.name) ?? "-"
              : I18n.t(`history_${mode === "chargers" ? "public" : "other"}`),
          [I18n.t("report_tariffName")]:
            (isValidValue(item.tariff?.name) && csvQuote(item.tariff.name)) ||
            "-",
          [I18n.t("report_tariffType")]:
            (isValidValue(item.tariff?.billingType) &&
              csvQuote(I18n.t("addTariff_" + item.tariff?.billingType))) ||
            "-",
          [I18n.t("report_activationFee")]: item.activationFee || "-",
          [I18n.t("report_tariffEnergy")]: item.tariffkWh || "-",
          [I18n.t("report_tariffTime")]: item.tariffMin || "-",
          [I18n.t("report_parkingDuringCharge")]:
            item.parkingDuringChargingAmount || "-",
          [I18n.t("report_parkingTariff")]: item.parkingAmount || "-",
          [I18n.t("myChargers_status")]:
            I18n.t(
              getTranslationKeyPaymentStatus(
                item.sessionBillingInfo?.sameUser.status
              )
            ) || "-",
          [I18n.t("addCard_cardNumber")]:
            item.cardNumber === "-1" ? "-" : item.cardNumber,
          [I18n.t("report_costPerKwExclVat")]:
            roundToDecimals(item.costPerkWh?.excl_vat, 4) || 0,
          [I18n.t("report_costPerKwInclVat")]:
            roundToDecimals(item.costPerkWh?.incl_vat, 4) || 0,
          [I18n.t("history_overcost")]: !isNaN(parseFloat(item.overcost))
            ? parseFloat(item.overcost).toFixed(2)
            : "-",
          [I18n.t("history_efficiency")]: !isNaN(parseFloat(item.efficiency))
            ? parseFloat(item.efficiency).toFixed(2)
            : "-",
        };

        newData.push(exportItem);
      });
    }
    return newData;
  }

  handleOnChangeResultsLimit(e) {
    const type = this.state.selectedTab === 0 ? "evs" : "chargers";
    const resultsLimit = parseInt(e.target.value);
    this.safeSetState(
      (prevState) => ({
        [type]: { ...prevState[type], resultsLimit, pageNumber: 1 },
      }),
      this.fetchHistory
    );
  }

  handleOnPageSwitch(_e, direction) {
    const type = this.state.selectedTab === 0 ? "evs" : "chargers";
    if (direction === "first" && this.state[type].pageNumber > 1) {
      this.safeSetState(
        (prevState) => ({
          [type]: { ...prevState[type], pageNumber: 1 },
        }),
        this.fetchHistory
      );
    } else if (direction === "left" && this.state[type].pageNumber > 1) {
      this.safeSetState(
        (prevState) => ({
          [type]: {
            ...prevState[type],
            pageNumber: prevState[type].pageNumber - 1,
          },
        }),
        this.fetchHistory
      );
    } else if (
      direction === "right" &&
      this.state[type].pageNumber < this.state[type].totalPages
    ) {
      this.safeSetState(
        (prevState) => ({
          [type]: {
            ...prevState[type],
            pageNumber: prevState[type].pageNumber + 1,
          },
        }),
        this.fetchHistory
      );
    } else if (
      direction === "last" &&
      this.state[type].pageNumber < this.state[type].totalPages
    ) {
      this.safeSetState(
        (prevState) => ({
          [type]: {
            ...prevState[type],
            pageNumber: this.state[type].totalPages,
          },
        }),
        this.fetchHistory
      );
    } else if (Number.isInteger(direction)) {
      this.safeSetState(
        (prevState) => ({
          [type]: { ...prevState[type], pageNumber: direction },
        }),
        this.fetchHistory
      );
    }
  }

  authTypeTranslationKey(authType) {
    return authType === "APP_USER"
      ? "history_appUser"
      : authType === "RFID"
      ? "history_rfid"
      : "history_unknown";
  }

  customStyles() {
    // from react-select docs (https://react-select.com/styles#provided-styles-and-state)
    // The recommended way to provide custom styles to react-select is to use the styles prop. styles takes an object with keys to represent the various inner components that react-select is made up of.

    const customStylesReactSelect = {
      control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        minHeight: "2.7rem",
        height: "2.7rem",
        padding: "0px 5px",
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "0px 1rem",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "2.7rem",
      }),
    };
    return customStylesReactSelect;
  }

  renderEvsTable() {
    if (this.state.evs.sessions.length > 0) {
      return this.state.evs.sessions
        .filter((i) => searchModule.filter(this, i))
        .map((i, idx) => {
          return (
            <div
              key={idx}
              className="row no-gutters"
              onClick={() =>
                this.safeSetState({ selectedItem: i }, () =>
                  this.setModal("info", true),
                )
              }
            >
              <div className="col-12 row no-gutters values">
                <div className="col staticColumnWidth">
                  {formatDate(i.startDate, "datetime")}
                </div>
                <div className="col staticColumnWidth">
                  {(i.fleet && i.fleet.name) || "-"}
                </div>
                <div className="col staticColumnWidth">
                  <span>{(i.ev && i.ev.licensePlate) || "-"}</span>
                </div>
                {this.props.accountData.userPackage?.mileageEntryEnabled && (
                  <div className="col staticColumnWidth">
                    <span>{(i.evKms && i.evKms?.kms) || "-"}</span>
                  </div>
                )}
                <div className="col staticColumnWidth">
                  {i.totalTimeInMin || 0}
                </div>
                <div className="col staticColumnWidth">
                  {!Number.isNaN(i.totalPower)
                    ? `${
                        i.totalPower < 1
                          ? `${roundToDecimals(i.totalPower * 1000, 2)}Wh`
                          : `${roundToDecimals(i.totalPower, 2)}kWh`
                      }`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i.user ? (
                    i.user.name || i.user.name === "" ? (
                      i.user.name
                    ) : (
                      <Translate value="history_other" />
                    )
                  ) : (
                    "-"
                  )}
                </div>
                <div className="col staticColumnWidth">
                  {i.charger?.network === "history_internalNetwork" ? (
                    <Translate value={i.charger?.network} />
                  ) : (
                    (i.charger?.network ?? "-")
                  )}
                </div>
                <div className="col staticColumnWidth">
                  {i.charger?.countryCode ?? "-"}
                </div>
                <div className="col staticColumnWidth">
                  <span className="ellipsis" title={i.charger?.hwId ?? "-"}>
                    {i.charger?.hwId ?? "-"}
                  </span>
                </div>
                <div className="col staticColumnWidth">
                  <div className="plug-info-container">
                    <span className="plug-type">
                      {this.getPlugTypeUsed(i?.charger, i?.plugId)}
                    </span>
                    <span className="plug-potency">
                      {I18n.t("chargerTitle_power") +
                        ": " +
                        this.getPotencyUsed(i?.charger, i?.plugId)}
                    </span>
                  </div>
                </div>
                <div className="col staticColumnWidth">
                  {!isNaN(i.evPlugPower) && i.evPlugPower !== 0
                    ? i.evPlugPower
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {isValidDurationCdr(i, "hours")
                    ? "-"
                    : i.totalPrice &&
                        !Number.isNaN(
                          i.totalPrice[
                            this.state.evs.withVat ? "incl_vat" : "excl_vat"
                          ],
                        )
                      ? `${roundToDecimals(
                          i.totalPrice[
                            this.state.evs.withVat ? "incl_vat" : "excl_vat"
                          ],
                          2,
                        )} €`
                      : "-"}
                </div>
                {/* possible authType APP_USER,RFID,Unknown */}
                <div className="col staticColumnWidth">
                  {I18n.t(this.authTypeTranslationKey(i.authType))}
                </div>
                <div className="col staticColumnWidth">
                  {isValidDurationCdr(i, "hours")
                    ? "-"
                    : i.costPerkWh &&
                        !Number.isNaN(
                          i.costPerkWh[
                            this.state.evs.withVat ? "incl_vat" : "excl_vat"
                          ],
                        )
                      ? `${roundToDecimals(
                          i.costPerkWh[
                            this.state.evs.withVat ? "incl_vat" : "excl_vat"
                          ],
                          2,
                        )} €`
                      : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i.overcost && !isNaN(i.overcost)
                    ? this.renderOvercost(i.overcost || 0)
                    : i.overcost && !isNaN(i.overcost)
                      ? `${parseFloat(i.overcost).toFixed(2)} %`
                      : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {this.props.isAdmin && i.efficiency && !isNaN(i.efficiency)
                    ? this.renderOvertime(i.efficiency || 0)
                    : i.efficiency && !isNaN(i.efficiency)
                      ? `${parseFloat(i.efficiency).toFixed(2)} %`
                      : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {!isNaN(i.plugChoice)
                    ? this.renderPlugchoice(i.plugChoice)
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {this.renderSwitchUpdated(i.sessionBillingInfo)}
                </div>
                {this.props.isAdmin && this.state.evioToggle ? (
                  <>
                    <div className="col staticColumnWidth">
                      {i.invoice &&
                      i.invoice.length > 0 &&
                      i.invoice[i.invoice.length - 1].invoiceDocumentNumber
                        ? i.invoice[i.invoice.length - 1].invoiceDocumentNumber
                        : "-"}
                    </div>
                    <div className="col staticColumnWidth">
                      {i.invoice &&
                      i.invoice.length > 0 &&
                      i.invoice[i.invoice.length - 1].creditNoteDocumentNumber
                        ? i.invoice[i.invoice.length - 1].creditNoteDocumentNumber
                        : "-"}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          );
        });
    } else {
      return (
        <div className="no-data-for-filters-container">
          <Translate value="history_noDataForFilters" />
        </div>
      );
    }
  }

  renderChargersTable() {
    if (this.state.chargers.sessions.length > 0) {
      return this.state.chargers.sessions
        .filter((i) => searchModule.filter(this, i))
        .map((i, idx) => {
          return (
            <div
              key={idx}
              className="row no-gutters"
              onClick={() =>
                this.safeSetState({ selectedItem: i }, () =>
                  this.setModal("info", true)
                )
              }
            >
              <div className="col-12 row no-gutters values">
                <div className="col staticColumnWidth">
                  {formatDate(i.startDate, "datetime")}
                </div>
                <div className="col staticColumnWidth">
                  {i?.charger?.address ? parseAddress(i.charger.address) : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i?.charger?.name ?? i?.charger?.hwId ?? "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i.totalTimeInMin || 0}
                </div>
                <div className="col staticColumnWidth1">
                  {!Number.isNaN(i.totalPower)
                    ? `${
                        i.totalPower < 1
                          ? `${roundToDecimals(i.totalPower * 1000, 2)}Wh`
                          : `${roundToDecimals(i.totalPower, 2)}kWh`
                      }`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {typeof i.fleet === "object" ? (
                    i.fleet?.name ?? "-"
                  ) : (
                    <Translate value="history_public" />
                  )}
                </div>
                <div className="col staticColumnWidth">
                  {i.ev?.licensePlate ?? "-"}
                </div>
                <div className="col staticColumnWidth">
                  {typeof i.user === "object" ? i.user?.name ?? "-" : i.user}
                </div>
                <div className="col staticColumnWidth">
                  {i?.charger?.network ?? "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i.purchaseTariffDetails &&
                  !Number.isNaN(
                    i.purchaseTariffDetails[
                      this.state.chargers.withVat ? "incl_vat" : "excl_vat"
                    ]
                  )
                    ? `${roundToDecimals(
                        i.purchaseTariffDetails[
                          this.state.chargers.withVat ? "incl_vat" : "excl_vat"
                        ],
                        2
                      )} €`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {i.totalPrice &&
                  !Number.isNaN(
                    i.totalPrice[
                      this.state.chargers.withVat ? "incl_vat" : "excl_vat"
                    ]
                  )
                    ? `${roundToDecimals(
                        i.totalPrice[
                          this.state.chargers.withVat ? "incl_vat" : "excl_vat"
                        ],
                        2
                      )} €`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {isValidDurationCdr(i, "hours")
                    ? "-"
                    : i.costPerkWh &&
                      !Number.isNaN(
                        i.costPerkWh[
                          this.state.evs.withVat ? "incl_vat" : "excl_vat"
                        ]
                      )
                    ? `${roundToDecimals(
                        i.costPerkWh[
                          this.state.evs.withVat ? "incl_vat" : "excl_vat"
                        ],
                        2
                      )} €`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {!Number.isNaN(parseFloat(i.overcost))
                    ? `${parseFloat(i.overcost).toFixed(2)} %`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {!Number.isNaN(parseFloat(i.efficiency))
                    ? `${parseFloat(i.efficiency).toFixed(2)} %`
                    : "-"}
                </div>
                <div className="col staticColumnWidth">
                  {this.renderSwitchUpdated(i.sessionBillingInfo)}
                </div>
              </div>
            </div>
          );
        });
    } else {
      return (
        <div className="no-data-for-filters-container">
          <Translate value="history_noDataForFilters" />
        </div>
      );
    }
  }

  //Renders the Evs Section tab from component selector
  renderEvsSection(d) {
    // This options encapsulate the defaults inside the filters
    const defaultOption = { value: "", label: I18n.t("history_all") };
    const displayNames = this.displayNames;

    const Option = (props) => {
      return (
        <div>
          <components.Option {...props} >
            <input
              type="checkbox"
              checked={props.isSelected}
              readOnly
              style={{ verticalAlign: "middle" }}
            />
            <label style={{ paddingLeft: "1rem", verticalAlign: "middle", marginBottom: 0 }}>
              {props.value !== "All"
                ? (displayNames.of(props?.value) || props?.value)
                : I18n.t("history_all")
              }
            </label>
          </components.Option>
        </div>
      );
    };

    const MultiValue = (props) => {
      const selected = props.selectProps.value;
      const index = selected.findIndex(v => v.value === props.data.value);
      if (selected.length === 1) {
        return <span>{props.data.label}</span>;
      } else if (index === 0) {
        const found = this.state.listOfSelectedCountries.find(
          (element) => element.value === "All",
        );

        if(found !== undefined) {
          return <span>{selected.length - 1 + " " + I18n.t("networks_countries")}</span>;
        } else{
          return <span>{selected.length + " " + I18n.t("networks_countries")}</span>;
        }
        
      } else {
        return null;
      }
    };

    const countryNetworkSelectStyles = {
      multiValue: (provided, state) => ({
        ...provided,
        whiteSpace: "nowrap",
        display: state.selectProps.inputValue ? "none" : "flex",
        paddingTop: "0px",
      }),
      placeholder: (provided) => ({
        ...provided,
      }),
      menu: (provided) => ({
        ...provided,
        width: "100%",
        minWidth: 200,
        marginTop: "0px",
        paddingTop: "0px",
      }),
      control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        minHeight: "2.7rem",
        height: "2.7rem",
        padding: "0px 5px",
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "0px 1rem",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "2.7rem",
      }),
    };

    return (
      <div className="main-container">
        <div
          className={"control-bar " + (this.state.isScrolled ? "shadowed" : "")}
        >
          <div style={{ maxWidth: "80%", display: "flex", flexWrap: "wrap" }}>
            {!this.state.evs.loading && (
              <>
                <div
                  className="select-label-container"
                  style={{ marginBottom: "2rem" }}
                >
                  <p>
                    <Translate value="history_fleet" />
                  </p>

                  <div className="smartSelect">
                    <Select
                      styles={this.customStyles()}
                      value={this.state.selectedFleet || defaultOption}
                      onChange={(e) => {
                        this.handleOnChangeFilter(
                          this.convertToSmartSelection(
                            this.state.fleets,
                            true,
                            e.value,
                          ),
                          "fleet",
                        );
                        this.setState({ selectedFleet: e });
                      }}
                      defaultValue={defaultOption}
                      options={this.convertToSmartSelection(
                        this.state.fleets,
                        false,
                        null,
                        "name",
                      )}
                    />
                  </div>
                </div>

                {this.state.evs.filter.fleet !== "" && (
                  <div className="select-label-container">
                    <p>
                      <Translate value="history_ev" />
                    </p>
                    <div className="smartSelect">
                      <Select
                        styles={this.customStyles()}
                        value={this.state.selectedEv || defaultOption}
                        onChange={(e) => {
                          this.handleOnChangeFilter(
                            this.convertToSmartSelection(
                              this.state.fleets[this.state.evs.filter.fleet]
                                ?.listEvs,
                              true,
                              e.value,
                            ),
                            "ev",
                          );
                          this.setState({ selectedEv: e });
                        }}
                        defaultValue={defaultOption}
                        options={this.convertToSmartSelection(
                          this.state.fleets[this.state.evs.filter.fleet]
                            ?.listEvs,
                          false,
                          null,
                          "licensePlate",
                        )}
                      />
                    </div>
                  </div>
                )}

                <div className="select-label-container">
                  <p>
                    <Translate value="history_group" />
                  </p>
                  <div style={{ width: "10rem" }}>
                    <Select
                      styles={this.customStyles()}
                      value={this.state.selectedGroup || defaultOption}
                      onChange={(e) => {
                        this.handleOnChangeFilter(
                          this.convertToSmartSelection(
                            this.state.groups,
                            true,
                            e.value,
                          ),
                          "group",
                        );
                        this.setState({ selectedGroup: e });
                      }}
                      defaultValue={defaultOption}
                      options={this.convertToSmartSelection(
                        this.state.groups,
                        false,
                        null,
                        "name",
                      )}
                    />
                  </div>
                </div>

                {this.state.evs.filter.group !== "" && (
                  <div className="select-label-container">
                    <p>
                      <Translate value="history_user" />
                    </p>
                    <div style={{ width: "10rem" }}>
                      <Select
                        styles={this.customStyles()}
                        value={this.state.selectedUser || defaultOption}
                        onChange={(e) => {
                          this.handleOnChangeFilter(
                            this.convertToSmartSelection(
                              this.state.groups[this.state.evs.filter.group]
                                .listOfDrivers,
                              true,
                              e.value,
                            ),
                            "user",
                          );
                          this.setState({ selectedUser: e });
                        }}
                        defaultValue={defaultOption}
                        options={this.convertToSmartSelection(
                          this.state.groups[this.state.evs.filter.group]
                            .listOfDrivers,
                          false,
                          null,
                          "name",
                        )}
                      />
                    </div>
                  </div>
                )}

                <div className="select-label-container">
                  <p>
                    <Translate value="history_network" />
                  </p>
                  <div style={{ width: "10rem" }}>
                    <Select
                      styles={this.customStyles()}
                      value={this.state.selectedNetwork || defaultOption}
                      onChange={(e) => {
                        this.handleOnChangeFilter(e.value, "network");
                        this.setState({ selectedNetwork: e });
                      }}
                      defaultValue={defaultOption}
                      options={getOptionsNetwork(this.props?.brand?.brandName)}
                    />
                  </div>
                </div>

                {this.state.evs &&
                  this.state.evs.filter &&
                  this.state.evs.filter.network &&
                  this.state.evs.filter.network !== "" &&
                  this.state.evs.filter.network !== "INTERNAL" && (
                    <div className="select-label-container">
                      <p>{I18n.t("filters_countryNetwork")}</p>
                      <div style={{ width: "15rem" }}>
                        <Select
                          closeMenuOnSelect={false}
                          isMulti
                          components={{
                            Option,
                            MultiValue,
                            ClearIndicator: null,
                          }}
                          defaultValue={
                            this.state.listOfCountries &&
                            this.state.listOfCountries.length > 0
                              ? this.state.listOfCountries[0]
                              : null
                          }
                          options={this.state.listOfCountries}
                          hideSelectedOptions={false}
                          backspaceRemovesValue={false}
                          styles={countryNetworkSelectStyles}
                          value={this.state.listOfSelectedCountries}
                          menuIsOpen={this.state.countryDropdownOpen}
                          onMenuOpen={() =>
                            this.setState({ countryDropdownOpen: true })
                          }
                          onMenuClose={() => {
                            this.setState({ countryDropdownOpen: false });
                            this.fetchHistory();
                          }}
                          onChange={(selected, action) => {
                            if (
                              Array.isArray(selected) &&
                              selected.some((opt) => opt.label === "ALL") &&
                              action.action === "select-option"
                            ) {
                              // Select all countries
                              this.setState({
                                listOfSelectedCountries: [
                                  ...this.state.listOfCountries,
                                ],
                                countryDropdownOpen: false,
                              });
                            } else if (
                              action.action === "deselect-option" &&
                              action.option.label === "ALL"
                            ) {
                              // Deselect all
                              this.setState({ listOfSelectedCountries: [] });
                            } else if (
                              action.action === "deselect-option" &&
                              Array.isArray(
                                this.state.listOfSelectedCountries,
                              ) &&
                              this.state.listOfSelectedCountries.some(
                                (opt) => opt.label === "ALL",
                              )
                            ) {
                              // If 'ALL' was selected and user removes a country, remove 'ALL' from selection but keep the rest
                              const filtered = (selected || []).filter(
                                (opt) => opt.label !== "ALL",
                              );
                              this.setState({
                                listOfSelectedCountries: filtered,
                              });
                            } else {
                              this.setState({
                                listOfSelectedCountries: selected,
                              });
                            }
                          }}
                          placeholder=""
                        />
                      </div>
                    </div>
                  )}
              </>
            )}
          </div>
          <div className="date-controls" style={{ marginBottom: "2rem" }}>
            <div className="date-container">
              <input
                type="date"
                max={
                  this.state.to !== ""
                    ? moment(this.state.to).format("YYYY-MM-DD")
                    : ""
                }
                value={
                  this.state.from
                    ? moment(this.state.from).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  this.resetSelects();
                  this.handleOnDateChange(e, "from");
                }}
              />
              <input
                type="text"
                value={
                  this.state.from
                    ? moment(this.state.from).format("DD/MM/YYYY")
                    : I18n.t("insights_startDate")
                }
                readOnly
              />
            </div>
            <img alt="evio_img6" src={arrow} />
            <div className="date-container">
              <input
                type="date"
                min={moment(
                  this.state.from !== "" ? this.state.from : d,
                ).format("YYYY-MM-DD")}
                max={moment(d).format("YYYY-MM-DD")}
                value={
                  this.state.to
                    ? moment(this.state.to).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  this.resetSelects();
                  this.handleOnDateChange(e, "to");
                }}
              />
              <input
                type="text"
                value={
                  this.state.to
                    ? moment(this.state.to).format("DD/MM/YYYY")
                    : I18n.t("insights_endDate")
                }
                readOnly
              />
            </div>
          </div>
        </div>

        {!this.state.evs.loading ? (
          <>
            <div className="component-container">
              <div className="table-container containerOverflowY">
                <div className="table-header width150">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "fees",
                            (item) => item.fees?.startDate || 0,
                          )
                        }
                      >
                        <Translate value="history_datetime" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "name",
                            (item) => item.fleet?.name || "outros",
                          )
                        }
                      >
                        <Translate value="history_fleet" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "licensePlate",
                            (item) => item.ev?.licensePlate || "",
                          )
                        }
                      >
                        <Translate value="history_ev" />
                      </div>
                      {this.props.accountData.userPackage
                        ?.mileageEntryEnabled && (
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "kms",
                              (item) => item.evKms?.kms || "",
                            )
                          }
                        >
                          <Translate value="mileage_km_label" />
                        </div>
                      )}

                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "timeCharged",
                            (item) => item?.timeCharged || 0,
                          )
                        }
                      >
                        <Translate value="history_duration" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "totalPower",
                            (item) => item?.totalPower || 0,
                          )
                        }
                      >
                        <Translate value="history_energy" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows("name", (item) => item.user?.name)
                        }
                      >
                        <Translate value="history_userName" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows("network", (item) => item?.network)
                        }
                      >
                        <Translate value="history_network" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "country",
                            (item) => item.charger?.countryCode,
                          )
                        }
                      >
                        <Translate value="accountDetails_country" />
                      </div>
                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows("hwId", (item) => item?.hwId || 0)
                        }
                      >
                        <Translate value="history_charger" />
                      </div>
                      <div className="col title header-cell">
                        <Translate value="history_plugAndPower" />
                      </div>
                      <div
                        className="col title header-cell"
                        style={{ cursor: "pointer" }}
                      >
                        <Translate value="history_evPlugPower" />
                      </div>
                      <div className="col title header-cell">
                        <div
                          onClick={() =>
                            this.sortTableRows(
                              "excl_vat",
                              (item) => item.totalPrice?.excl_vat || 0,
                            )
                          }
                        >
                          <Translate value="history_cost" />
                        </div>
                        (
                        <label htmlFor="withVat">
                          <Translate value="history_withVat" />
                        </label>
                        <input
                          id="withVat"
                          type="checkbox"
                          checked={this.state.evs.withVat}
                          onChange={this.handleOnChangeWithVat}
                        />
                        )
                      </div>
                      <div className="col title header-cell">
                        {I18n.t("mobieTariffPrice_startDate")}
                      </div>
                      <div className="col title header-cell">
                        <div
                          onClick={() =>
                            this.sortTableRows(
                              "excl_vat",
                              (item) => item.costPerkWh?.excl_vat || 0,
                            )
                          }
                        >
                          <Translate value="history_costPerKw" />
                        </div>
                        (
                        <label htmlFor="withVat">
                          <Translate value="history_withVat" />
                        </label>
                        <input
                          id="withVat"
                          type="checkbox"
                          checked={this.state.evs.withVat}
                          onChange={this.handleOnChangeWithVat}
                        />
                        )
                      </div>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={this.renderTooltipOvercostColumn()}
                      >
                        <div
                          className="col title header-cell"
                          style={{ cursor: "pointer" }}
                        >
                          {I18n.t("history_overcost")}
                          <FaInfoCircle
                            size={15}
                            color="#FFFFFF"
                            style={{ marginLeft: "2px" }}
                          />
                        </div>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={this.renderTooltipOvertimeColumn()}
                      >
                        <div
                          className="col title header-cell"
                          style={{ cursor: "pointer" }}
                        >
                          {I18n.t("history_efficiency")}
                          <FaInfoCircle
                            size={15}
                            color="#FFFFFF"
                            style={{ marginLeft: "2px" }}
                          />
                        </div>
                      </OverlayTrigger>
                      {this.state.evioTogglePlugChoice && this.props.isAdmin ? (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={this.renderTooltipPlugChoiceColumn()}
                        >
                          <div
                            className="col title header-cell"
                            style={{ cursor: "pointer" }}
                          >
                            {I18n.t("history_plugChoice")}
                            <FaInfoCircle
                              size={15}
                              color="#FFFFFF"
                              style={{ marginLeft: "2px" }}
                            />
                          </div>
                        </OverlayTrigger>
                      ) : null}

                      <div
                        className="col title header-cell"
                        onClick={() =>
                          this.sortTableRows(
                            "paymentBillingInfo",
                            (item) => item.paymentBillingInfo || 0,
                          )
                        }
                      >
                        <Translate value="myChargers_status" />
                      </div>
                      {this.props.isAdmin && this.state.evioToggle ? (
                        <>
                          <div className="col title header-cell">
                            <Translate value="history_invoice" />
                          </div>
                          <div className="col title header-cell">
                            <Translate value="history_creditNote" />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="table-values width150">
                  {this.renderEvsTable()}
                </div>
              </div>
            </div>
            {this.state.evs.sessions.length > 0 && (
              <div className="main-container-footer">
                <div className="select-container">
                  <label>
                    <Translate value="history_resultsLimit" />
                  </label>
                  <select
                    name="resultsLimit"
                    value={this.state.evs.resultsLimit}
                    onChange={this.handleOnChangeResultsLimit}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                  </select>
                </div>

                <PageSelector
                  totalPages={this.state.evs.totalPages}
                  selected={this.state.evs.pageNumber}
                  onPageSwitch={this.handleOnPageSwitch}
                />

                <button
                  type="button"
                  className="export-btn-history"
                  onClick={() => this.setModal("choice", true)}
                >
                  <div className="export-bt-text">
                    <Translate value="history_export" />
                  </div>
                  <img alt="evio_img7" src={download} />
                </button>
              </div>
            )}

            <ChoiceModal
              show={this.state.modals.choice}
              onHide={() => this.setModal("choice", false)}
              choices={[
                { content: "CSV", name: "csv" },
                { content: "XLSX", name: "xlsx" },
                { content: "PDF", name: "pdf", disabled: true },
              ]}
              chooseBtnLabel="history_export"
              onChoose={(e) => this.handleOnChoose(e, "evs")}
              btnWrapper={(btn, selected) =>
                selected && selected.name === "pdf" ? (
                  <ReactToPrint
                    content={() => this.componentRef}
                    //trigger={() => btn}
                    onBeforeGetContent={() =>
                      new Promise((resolve) =>
                        this.fetchHistory("evs", {
                          toExport: true,
                          withVat: this.state.evs.withVat,
                          callback: () => {
                            this.setModal("choice", false);
                            resolve();
                          },
                        }),
                      )
                    }
                  />
                ) : (
                  btn
                )
              }
            />

            <div id="downloadFile" style={{ visibility: "hidden" }} />
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  convertToSmartSelection(data, index, value, searchParam, network) {
    const options = [
      { value: "", label: I18n.t("history_all") },
      ...data.map((dataValue) => ({
        value: network ? dataValue.value : dataValue?._id,
        label: dataValue[searchParam],
      })),
    ];

    if (index) {
      if (value == "others") {
        return "Others";
      }
      const foundIndex = options.findIndex((option) => option.value === value);
      return foundIndex - 1;
    } else {
      return options;
    }
  }

  convertToSmartSelectionOthers(data, index, value, searchParam, network) {
    const options = [
      { value: "", label: I18n.t("history_all") },
      ...data.map((dataValue) => ({
        value: network ? dataValue.value : dataValue?._id,
        label: dataValue[searchParam],
      })),
    ];
    options.push({ value: "Others", label: I18n.t("history_other") });

    if (index) {
      if (value == "Others") {
        return value;
      }
      const foundIndex = options.findIndex((option) => option.value === value);
      return foundIndex - 1;
    } else {
      return options;
    }
  }

  //Renders the Chargers Section tab from component selector
  renderChargersSection(d) {
    const defaultOption = { value: "", label: I18n.t("history_all") };
    const defaultOption2 = [
      { _id: this.props.accountData.id, name: this.props.accountData.name },
      { _id: "others", name: I18n.t("history_public") },
    ];

    return (
      <div className="main-container">
        <div
          className={"control-bar " + (this.state.isScrolled ? "shadowed" : "")}
        >
          {!this.state.chargers.loading && (
            <>
              <div className="select-label-container">
                <p>
                  <Translate value="history_infrastructure" />
                </p>
                <div className="smartSelect">
                  <Select
                    styles={this.customStyles()}
                    value={this.state.selectedInfrastructure || defaultOption}
                    onChange={(e) => {
                      this.handleOnChangeFilter(
                        this.convertToSmartSelection(
                          this.state.infrastructures,
                          true,
                          e.value
                        ),
                        "infrastructure"
                      );
                      this.setState({ selectedInfrastructure: e });
                    }}
                    defaultValue={defaultOption}
                    options={this.convertToSmartSelection(
                      this.state.infrastructures,
                      false,
                      null,
                      "name"
                    )}
                  />
                </div>
              </div>

              {this.state.chargers.filter.infrastructure !== "" && (
                <div className="select-label-container">
                  <p>
                    <Translate value="history_charger" />
                  </p>
                  <div className="smartSelect">
                    <Select
                      styles={this.customStyles()}
                      value={this.state.selectedCharger || defaultOption}
                      onChange={(e) => {
                        this.handleOnChangeFilter(
                          this.convertToSmartSelection(
                            this.state.infrastructures[
                              this.state.chargers.filter.infrastructure
                            ].listChargers,
                            true,
                            e.value
                          ),
                          "charger"
                        );
                        this.setState({ selectedCharger: e });
                      }}
                      defaultValue={defaultOption}
                      options={this.convertToSmartSelection(
                        this.state.infrastructures[
                          this.state.chargers.filter.infrastructure
                        ].listChargers,
                        false,
                        null,
                        "name"
                      )}
                    />
                  </div>
                </div>
              )}

              <div className="select-label-container">
                <p>
                  <Translate value="history_fleet" />
                </p>
                <div style={{ width: "10rem" }}>
                  <Select
                    styles={this.customStyles()}
                    value={this.state.selectedFleetCharger || defaultOption}
                    onChange={(e) => {
                      this.handleOnChangeFilter(
                        this.convertToSmartSelection(
                          this.state.fleets,
                          true,
                          e.value
                        ),
                        "fleet"
                      );
                      this.setState({ selectedFleetCharger: e });
                    }}
                    defaultValue={defaultOption}
                    options={this.convertToSmartSelection(
                      this.state.fleets,
                      false,
                      null,
                      "name"
                    )}
                  />
                </div>
              </div>

              {this.state.chargers.filter.fleet !== "" &&
                this.state.chargers.filter.fleet !== "Others" && (
                  <div className="select-label-container">
                    <p>
                      <Translate value="history_ev" />
                    </p>
                    <div style={{ width: "10rem" }}>
                      <Select
                        styles={this.customStyles()}
                        value={this.state.selectedOther || defaultOption}
                        onChange={(e) => {
                          this.handleOnChangeFilter(
                            this.convertToSmartSelection(
                              this.state.fleets[
                                this.state.chargers.filter.fleet
                              ].listEvs,
                              true,
                              e.value
                            ),
                            "ev"
                          );
                          this.setState({ selectedOther: e });
                        }}
                        defaultValue={defaultOption}
                        options={this.convertToSmartSelection(
                          this.state.fleets[this.state.chargers.filter.fleet]
                            .listEvs,
                          false,
                          null,
                          "licensePlate"
                        )}
                      />
                    </div>
                  </div>
                )}

              <div className="select-label-container">
                <p>
                  <Translate value="history_group" />
                </p>
                <div style={{ width: "10rem" }}>
                  <Select
                    styles={this.customStyles()}
                    value={this.state.selectedGroup || defaultOption}
                    onChange={(e) => {
                      this.handleOnChangeFilter(
                        this.convertToSmartSelectionOthers(
                          this.state.csGroups,
                          true,
                          e.value
                        ),
                        "group"
                      );
                      this.setState({ selectedGroup: e });
                    }}
                    defaultValue={defaultOption}
                    options={this.convertToSmartSelectionOthers(
                      this.state.csGroups,
                      false,
                      null,
                      "name"
                    )}
                  />
                </div>
              </div>

              {this.state.chargers.filter.group !== "" && (
                <div className="select-label-container">
                  <p>
                    <Translate value="history_user" />
                  </p>
                  <div style={{ width: "10rem" }}>
                    <Select
                      styles={this.customStyles()}
                      value={this.state.selectedUserFilter || defaultOption}
                      onChange={(e) => {
                        this.handleOnChangeFilter(
                          this.convertToSmartSelection(
                            this.state.chargers.filter.group !== "Others"
                              ? this.state.csGroups[
                                  this.state.chargers.filter.group
                                ].listOfUsers.filter(
                                  (user) => user.userId && user.userId !== ""
                                )
                              : defaultOption2,
                            true,
                            e.value
                          ),
                          "user"
                        );
                        this.setState({ selectedUserFilter: e });
                      }}
                      defaultValue={defaultOption}
                      options={this.convertToSmartSelection(
                        this.state.chargers.filter.group !== "Others"
                          ? this.state.csGroups[
                              this.state.chargers.filter.group
                            ].listOfUsers.filter(
                              (user) => user.userId && user.userId !== ""
                            )
                          : defaultOption2,
                        false,
                        "others",
                        "name"
                      )}
                    />
                  </div>
                </div>
              )}
            </>
          )}

          <div className="date-controls">
            <div className="date-container">
              <input
                type="date"
                max={
                  this.state.to !== ""
                    ? moment(this.state.to).format("YYYY-MM-DD")
                    : ""
                }
                value={
                  this.state.from
                    ? moment(this.state.from).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  this.resetSelects();
                  this.handleOnDateChange(e, "from");
                }}
              />
              <input
                type="text"
                value={
                  this.state.from
                    ? formatDate(this.state.from, "date")
                    : I18n.t("insights_startDate")
                }
                readOnly
              />
            </div>
            <img alt="evio_img13" src={arrow} />
            <div className="date-container">
              <input
                type="date"
                min={moment(
                  this.state.from !== "" ? this.state.from : d
                ).format("YYYY-MM-DD")}
                max={moment(d).format("YYYY-MM-DD")}
                value={
                  this.state.to
                    ? moment(this.state.to).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  this.resetSelects();
                  this.handleOnDateChange(e, "to");
                }}
              />
              <input
                type="text"
                value={
                  this.state.to
                    ? formatDate(this.state.to, "date")
                    : I18n.t("insights_endDate")
                }
                readOnly
              />
            </div>
          </div>
        </div>

          {!this.state.chargers.loading ? (
            <>
              <div className="component-container">
                <div className="table-container containerOverflowY">
                  <div className="table-header width150">
                    <div className="row no-gutters">
                      <div className="col-12 row no-gutters titles">
                        <div
                          className="col title"
                          onClick={() =>
                            this.sortTableRows(
                              "startDate",
                              (item) => item.startDate || 0
                            )
                          }
                        >
                          <Translate value="history_datetime" />
                        </div>
                        <div className="col title">
                          <Translate value="address_address" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "name",
                              (item) => item.charger?.name || "outros"
                            )
                          }
                        >
                          <Translate value="history_charger_name" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "timeCharged",
                              (item) => item.timeCharged || 0
                            )
                          }
                        >
                          <Translate value="history_duration" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "totalPower",
                              (item) => item.totalPower || 0
                            )
                          }
                        >
                          <Translate value="history_energy" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "name",
                              (item) => item.fleet.name || "outros"
                            )
                          }
                        >
                          <Translate value="history_fleet" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "licensePlate",
                              (item) => item.ev?.licensePlate || 0
                            )
                          }
                        >
                          <Translate value="history_ev" />
                        </div>

                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "name",
                              (item) => item.user.name || "outros"
                            )
                          }
                        >
                          <Translate value="history_userName" />
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "network",
                              (item) => item.network || "outros"
                            )
                          }
                        >
                          <Translate value="history_network" />
                        </div>
                        <div className="col title header-cell">
                          <div
                            onClick={() =>
                              this.sortTableRows(
                                "costWithVat",
                                (item) => item.totalPrice?.incl_vat || 0
                              )
                            }
                          >
                            <Translate value="history_cost" />
                          </div>
                          (
                          <label htmlFor="withVat">
                            <Translate value="history_withVat" />
                          </label>
                          <input
                            id="withVat"
                            type="checkbox"
                            checked={this.state.chargers.withVat}
                            onChange={this.handleOnChangeWithVat}
                          />
                          )
                        </div>
                        <div className="col title header-cell">
                          <Translate value="history_revenue" />(
                          <label htmlFor="withVat">
                            <Translate value="history_withVat" />
                          </label>
                          <input
                            id="withVat"
                            type="checkbox"
                            checked={this.state.chargers.withVat}
                            onChange={this.handleOnChangeWithVat}
                          />
                          )
                        </div>
                        <div className="col title header-cell">
                          <Translate value="history_costPerKw" />(
                          <label htmlFor="withVat">
                            <Translate value="history_withVat" />
                          </label>
                          <input
                            id="withVat"
                            type="checkbox"
                            checked={this.state.chargers.withVat}
                            onChange={this.handleOnChangeWithVat}
                          />
                          )
                        </div>
                        <div className="col title header-cell">
                          {I18n.t("history_overcost")}
                        </div>
                        <div className="col title header-cell">
                          {I18n.t("history_efficiency")}
                        </div>
                        <div
                          className="col title header-cell"
                          onClick={() =>
                            this.sortTableRows(
                              "paymentBillingInfo",
                              (item) => item.fees?.paymentBillingInfo || 0
                            )
                          }
                        >
                          <Translate value="myChargers_status" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-values width150">
                    {this.renderChargersTable()}
                  </div>
                </div>
              </div>
              {this.state.chargers.sessions.length > 0 && (
                <div className="main-container-footer">
                  <div className="select-container">
                    <label>
                      <Translate value="history_resultsLimit" />
                    </label>
                    <select
                      name="resultsLimit"
                      value={this.state.chargers.resultsLimit}
                      onChange={this.handleOnChangeResultsLimit}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                    </select>
                  </div>

                  <PageSelector
                    totalPages={this.state.chargers.totalPages}
                    selected={this.state.chargers.pageNumber}
                    onPageSwitch={this.handleOnPageSwitch}
                  />

                  <button
                    type="button"
                    className="export-btn-history"
                    onClick={() => this.setModal("choice", true)}
                  >
                    <div className="export-bt-text">
                      <Translate value="history_export" />
                    </div>
                    <img alt="evio_img7" src={download} />
                  </button>
                </div>
              )}

              <ChoiceModal
                show={this.state.modals.choice}
                onHide={() => this.setModal("choice", false)}
                choices={[
                  { content: "CSV", name: "csv" },
                  { content: "XLSX", name: "xlsx" },
                  { content: "PDF", name: "pdf", disabled: true },
                ]}
                chooseBtnLabel="history_export"
                onChoose={(e) => this.handleOnChoose(e, "chargers")}
                btnWrapper={(btn, selected) =>
                  selected && selected.name === "pdf" ? (
                    <ReactToPrint
                      content={() => this.componentRef}
                      //trigger={() => btn}
                      onBeforeGetContent={() =>
                        new Promise((resolve) =>
                          this.fetchHistory("chargers", {
                            toExport: true,
                            withVat: this.state.chargers.withVat,
                            callback: () => {
                              this.setModal("choice", false);
                              resolve();
                            },
                          })
                        )
                      }
                      onBeforePrint={() => this.setModal("choice", false)}
                    />
                  ) : (
                    btn
                  )
                }
              />

              <div id="downloadFile" style={{ visibility: "hidden" }} />
            </>
          ) : (
            <div className="loading-container">
              <div className="loading-spinner">
                <div className="generic-loading">
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  selectTab(_e, selectedTab) {
    this.safeSetState(
      { selectedTab: parseInt(selectedTab) },
      this.fetchHistory
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderSwitchUpdated(sessionBillingInfo) {
    let { description, status } = sessionBillingInfo?.sameUser || {};
    if (!status && !description) {
      description = "extraText_unknown";
      status = "UNKNOWN";
    }

    const statusContent = (
      <span className="d-inline-flex align-items-center status-container status-costumization">
        <span className={`status-payment status-${status}`}></span>
        <span className="status-payment-text status-costumization">
          <Translate value={getTranslationKeyPaymentStatus(status)} />
        </span>
      </span>
    );

    return description ? (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="text-tooltip">{I18n.t(description)}</Tooltip>}
      >
        {statusContent}
      </OverlayTrigger>
    ) : (
      statusContent
    );
  }

  overcostClassification(overcostPositiveValue) {
    // Find classification
    const classification =
      overcostMap.find(
        (c) => overcostPositiveValue >= c.min && overcostPositiveValue < c.max
      ) || overcostMap[0];
    return classification;
  }

  renderOvercost(overcost) {
    // Remove negative overcosts and count them as 0
    let overcostPositiveValue = overcost < 0 ? 0 : overcost;
    let overcostRounded = Number(overcostPositiveValue).toFixed(1);

    // Find classification
    const classification = this.overcostClassification(overcostPositiveValue);

    const statusContent = (
      <span className="d-inline-flex align-items-center ">
        <span
          className={`overcost-status-${classification.key} plug-choice-status-customization `}
        >
          <b>{classification.title}</b>
        </span>
      </span>
    );

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            <div className="tooltip-title">{classification.title}</div>
            <div className="tooltip-range">
              <Translate value="history_range" />: {overcostRounded}%
            </div>
            <div className="tooltip-description">
              {classification.description}
            </div>
          </Tooltip>
        }
      >
        {statusContent}
      </OverlayTrigger>
    );
  }

  efficiencyClassification(efficiency){
    const classification =
      overtimeMap.find(
        (c) => efficiency >= c.min && efficiency < c.max
      ) || overtimeMap[0];
    return classification;
  };

  renderOvertime(overtime) {
    // Remove negative overtime and count as 0
    let overtimePositiveValue = overtime < 0 ? 0 : overtime;
    let overtimeRounded = Number(overtimePositiveValue).toFixed(1);

    // Find classification
    const classification = this.efficiencyClassification(overtimePositiveValue);

    const statusContent = (
      <span className="d-inline-flex align-items-center ">
        <span
          className={`overtime-status-${classification.key} plug-choice-status-customization`}
        >
          <b>{classification.title}</b>
        </span>
      </span>
    );

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            <div className="tooltip-title">{classification.title}</div>
            <div className="tooltip-range">
              <Translate value="history_range" />: {overtimeRounded}%
            </div>
            <div className="tooltip-description">
              {classification.description}
            </div>
          </Tooltip>
        }
      >
        {statusContent}
      </OverlayTrigger>
    );
  }

  plugChoiceClassification(plugChoice){
    const classification =
      plugChoiceMap.find((c) => plugChoice >= c.min && plugChoice < c.max) ||
      plugChoiceMap[0];

    return classification;
  }

  renderPlugchoice(plugChoice) {
    // Remove negative plugChoice and count as 0
    let plugChoicePositiveValue = plugChoice < 0 ? 0 : plugChoice;
    let plugChoiceRounded = Number(plugChoicePositiveValue).toFixed(1);

    // Find classification
    const classification = this.plugChoiceClassification(
      plugChoicePositiveValue
    );

    const statusContent = (
      <span className="d-inline-flex align-items-center ">
        <span
          className={`plug-choice-status-${classification.key} plug-choice-status-customization`}
        >
          <b>{classification.title}</b>
        </span>
      </span>
    );

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            <div className="tooltip-title">{classification.title}</div>
            <div className="tooltip-range">
              <Translate value="history_range" />: {plugChoiceRounded}%
            </div>
            <div className="tooltip-description">
              {classification.description}
            </div>
          </Tooltip>
        }
      >
        {statusContent}
      </OverlayTrigger>
    );
  }

  renderTooltipOvercostColumn() {
    return (
      <div className="custom-tooltip-history">
        <div className="header-tooltip">
          <div className="header-tooltip-title">
            💰 {I18n.t("history_overcost_tooltip_title")}
          </div>
          <div className="header-tooltip-items">
            {overcostMap.map((c) => (
              <div className="header-tooltip-item" key={c.key}>
                <span className={`header-tooltip-badge status-${c.key}`}>
                  <span className="d-inline-flex align-items-center ">
                    <span
                      className={`overcost-status-${c.key} plug-choice-status-customization`}
                    >
                      <b>{c.title}</b>
                    </span>
                  </span>
                </span>
                <span className="header-tooltip-text">
                  <span className="header-tooltip-range">{c.range}</span> -{" "}
                  {c.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderTooltipOvertimeColumn() {
    return (
      <div className="custom-tooltip-history">
        <div className="header-tooltip">
          <div className="header-tooltip-title">
            📊 {I18n.t("history_overtime_tooltip_title")}
          </div>
          <div className="header-tooltip-items">
            {overtimeMap.map((c) => (
              <div className="header-tooltip-item" key={c.key}>
                <span className={`header-tooltip-badge status-${c.key}`}>
                  <span className="d-inline-flex align-items-center ">
                    <span
                      className={`overtime-status-${c.key} plug-choice-status-customization`}
                    >
                      <b>{c.title}</b>
                    </span>
                  </span>
                </span>
                <span className="header-tooltip-text">
                  <span className="header-tooltip-range">{c.range}</span> -{" "}
                  {c.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderTooltipPlugChoiceColumn() {
    return (
      <div className="custom-tooltip-history">
        <div className="header-tooltip">
          <div className="header-tooltip-title">
            🔌 {I18n.t("history_plugchoice_tooltip_title")}
          </div>
          <div className="header-tooltip-items">
            {plugChoiceMap.map((c) => (
              <div className="header-tooltip-item" key={c.key}>
                <span className={`header-tooltip-badge status-${c.key}`}>
                  <span className="d-inline-flex align-items-center ">
                    <span
                      className={`plug-choice-status-${c.key} plug-choice-status-customization`}
                    >
                      <b>{c.title}</b>
                    </span>
                  </span>
                </span>
                <span className="header-tooltip-text">
                  <span className="header-tooltip-range">{c.range}</span> -{" "}
                  {c.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const d = moment().startOf("day");
    return (
      <div id="history">
        <ComponentSelector
          tabs={[
            {
              title: (
                <div className="tab-title">
                  <CarIcon
                    fill={
                      (parseInt(this.state.selectedTab) === 0 &&
                        this.props.brand?.colors?.secondaryColor) ||
                      "#71778a"
                    }
                  />
                  <Translate value="history_myevs_tab" />
                </div>
              ),
              component: this.renderEvsSection(d),
            },
            {
              title: (
                <div className="tab-title">
                  <StationIcon
                    fill={
                      (parseInt(this.state.selectedTab) === 1 &&
                        this.props.brand?.colors?.secondaryColor) ||
                      "#71778a"
                    }
                  />
                  <Translate value="history_chargingStations_tab" />
                </div>
              ),

              component: this.renderChargersSection(d),
            },
          ]}
          updateSelectedTab={this.selectTab}
          renderTabs
        />

        {this.state.selectedItem !== null && (
          <ChargerSessionSummary
            show={this.state.modals.info}
            onHide={() => this.setModal("info", false)}
            selectedItem={this.state.selectedItem}
            withVat={
              this.state[this.state.selectedTab === 0 ? "evs" : "chargers"]
                .withVat
            }
            accountData={this.props.accountData}
            brand={this.props.brand}
            type={this.state.selectedTab === 0 ? "evs" : "chargers"}
          />
        )}

        {this.state.exportData !== null && (
          <div style={{ display: "none" }}>
            <Report
              groupBy={
                this.state.selectedTab === 0 ? "ev_history" : "charger_history"
              }
              timePeriod={{ from: this.state.from, to: this.state.to }}
              withVat={
                this.state[this.state.selectedTab === 0 ? "evs" : "chargers"]
                  .withVat
              }
              data={this.state.exportData}
              ref={(el) => (this.componentRef = el)}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.i18n,
  accountData: state.account.accountData,
  isAdmin: state.account.isAdmin,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert })(History);

